export enum FeatureFlag {
    AUTOPAY_ONBOARDING_STEP_SIMPLIFIED = `isAutopayOnboardingStepSimplified`,
    SSO_ENABLED = `isSsoEnabled`
}
